import React, { useState } from "react";
import Base from "../core/Base";
import HeaderTitle from "../components/HeaderTitle";
import $ from "jquery";

const Contact = () => {
  const [values, SetValues] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
    error: false,
    success: "",
  });
  const { name, email, mobile, message } = values;
  const handleChange = (name) => (e) => {
    SetValues({ ...values, [name]: e.target.value });
    console.log(values);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    let form = $(e.target)[0];
    fetch("/projects/english-tutor/api_public/students/login", {
      mode: "no-cors",
      method: "POST",
      body: new FormData(form),
    })
      .then((response) => response.json())
      .then((responseJson) => console.log(responseJson))
      .catch((err) => {
        console.log("Error", err);
      });
    SetValues({
      ...values,
      name: "",
      mobile: "",
      email: "",
      message: "",
      error: false,
      success: "",
    });
  };
  return (
    <Base>
      <HeaderTitle title="Contact Us" />
      <section className="contact-area ptb-100">
        <div className="container">
          <h3 className="text-center">Contact Us</h3>
          <div className="row">
            <div className="col-lg-4 col-md-12">
              <div className="leave-your-message">
                <h3>Leave Your Message</h3>
                <p>
                  If you have any questions about the services we provide simply
                  use the form below. We try and respond to all queries and
                  comments within 24 hours.
                </p>

                <div className="stay-connected">
                  <h3>Stay Connected</h3>
                  <ul>
                    <li>
                      <a
                        href="https://www.facebook.com/sarkarizone"
                        target="_blank"
                      >
                        <i className="icofont-facebook icons"></i>
                        <span>Facebook</span>
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/sarkarizone" target="_blank">
                        <i className="icofont-twitter icons"></i>
                        <span>Twitter</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/in/sarkari-zone-3386361b9/"
                        target="_blank"
                      >
                        <i className="icofont-linkedin icons"></i>
                        <span>Linkedin</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/sarkarizone"
                        target="_blank"
                      >
                        <i className="icofont-instagram icons"></i>
                        <span>Instagram</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://in.pinterest.com/sarkarizone/"
                        target="_blank"
                      >
                        <i className="icofont-pinterest icons"></i>
                        <span>Pinterest</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/channel/UCKpimXxJeSGeuuVfoCtL2aQ/videos"
                        target="_blank"
                      >
                        <i className="icofont-youtube-play icons"></i>
                        <span>Youtube</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <form id="contactForm" onSubmit={onSubmit} method="post">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label htmlFor="name">Name*</label>
                      <input
                        type="text"
                        className="form-control "
                        name="name"
                        id="name"
                        required=""
                        data-error="Please enter your name"
                        value={name}
                        onChange={handleChange("name")}
                      />
                      <div className="help-block with-errors"></div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label htmlFor="email">Email*</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        required=""
                        data-error="Please enter your email"
                        value={email}
                        onChange={handleChange("email")}
                      />
                      <div className="help-block with-errors"></div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label htmlFor="number">Mobile*</label>
                      <input
                        type="text"
                        className="form-control"
                        name="mobile"
                        id="number"
                        required=""
                        data-error="Please enter your number"
                        value={mobile}
                        onChange={handleChange("mobile")}
                      />
                      <div className="help-block with-errors"></div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label htmlFor="hours">Hours*</label>
                      <select className="form-control" name="hours" id="shift">
                        <option value="4 Hours">4 Hours</option>
                        <option value="6 Hours">6 Hours</option>
                        <option value="8 Hours">8 Hours</option>
                        <option value="12 Hours">12 Hours</option>
                      </select>
                      <div className="help-block with-errors"></div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <label htmlFor="message">Message*</label>
                      <textarea
                        name="message"
                        className="form-control"
                        id="message"
                        cols="30"
                        rows="4"
                        required=""
                        data-error="Write your message"
                        value={message}
                        onChange={handleChange("message")}
                      ></textarea>
                      <div className="help-block with-errors"></div>
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <button type="submit" className="btn btn-primary">
                      Send Message
                    </button>
                    <div id="msgSubmit" className="h3 text-center hidden"></div>
                    <div className="clearfix"></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Base>
  );
};

export default Contact;
